<template>
  <div class="s-modal__wrapper s-modal__wrapper--white">
    <div class="s-modal__header s-modal__header--transparent">
      <button id="s-modal-fail-close"
              type="button"
              class="s-modal__btn--close"
              aria-label="Close"
              @click="$emit('closePopup')"></button>
    </div>

    <div class="s-modal__body s-modal__body--fail" :class="{ peng: type === 'runner', jb: isJb }">
      <p class="s-modal__txt--fail">
        어이쿠, 다시해볼까요?<br>미션에 재도전해 보세요!
      </p>

      <button class="s-modal__btn--ws s-modal__btn--ws--single s-modal__btn--fail"
              @click="confirm">다시하기</button>
    </div>
  </div>
</template>

<script>
    export default {
      name: 'modalFailTemplate',
      props : {
          type: {},
          isJb: {}
        },
      data() {
        return {
          mainSrc: '/codmos/static/assets/logicong-study-resources/sound/fail_sound.mp3',
          mainSound: {}
        }
      },
      methods: {
        confirm() {
          this.$emit('confirm', function () {
            this.$refs.gamecanvas.restartCanvas()
          })
        },
        fail() {
          const SOUND_ENABLE = this.getCookie('soundEnable')
          if (
            typeof SOUND_ENABLE === 'undefined'
            || eval(SOUND_ENABLE)
          ) this.mainSound.play();
        }
      },
      mounted() {
        const sound = new Audio(this.mainSrc);
        this.mainSound = {
          isEnabled: true,
          play: () => {
            if (this.mainSound.isEnabled) {
              sound.volume = window.LC_VOLUME || 1;
              sound.play();
            }
          },
          stop: () => {
            sound.pause();
            sound.currentTime = 0;
            this.mainSound.isEnabled = false;
          },
          stopAndPlay: () =>{
            if (this.mainSound.isEnabled) {
              sound.pause();
              sound.currentTime = 0;
              sound.play();
            }
          },
          toggle: () => {
            if (this.mainSound.isEnabled) {
              this.mainSound.stop();
            } else {
              this.mainSound.isEnabled = true;
              this.mainSound.play();
            }
          }
        };
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/stage/modal/ModalPartialFail.vue